import { Outlet, Link } from "react-router-dom";
import '../asset/main.css'
import AlertLineIcon from 'remixicon-react/AlertLineIcon';
import Fbicon from 'remixicon-react/FacebookCircleFillIcon'
import Moonicon from 'remixicon-react/MoonFillIcon'
import SunFill from 'remixicon-react/SunFillIcon'
import Instaricon from 'remixicon-react/InstagramLineIcon'
import Linkedicon from 'remixicon-react/LinkedinFillIcon'
import Githubicon from 'remixicon-react/GithubFillIcon'
import MenuLine from 'remixicon-react/Menu5LineIcon'
import Barbox from 'remixicon-react/TerminalBoxFillIcon'
import Close from 'remixicon-react/CloseLineIcon'
import Block from 'remixicon-react/GitRepositoryPrivateFillIcon'
import Add from 'remixicon-react/AddBoxLineIcon'
import Profile from 'remixicon-react/ProfileLineIcon'
import Shield from 'remixicon-react/ShieldLineIcon'
import { useState } from "react";
import { useSpring, animated } from 'react-spring';
import AddProject from "../components/boxAddProject";
import AddAbout from "../components/boxAddAbout"
import EditHome from "../components/boxHomeInfo"

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDarkMode } from "../DarkModeContext";
import passcode from "../passcode"





// #293A80


export default function Layout() {

    const navigate = useNavigate();

    const { darkMode, toggleDarkMode } = useDarkMode();

    const turnOnDarkMode = () => {
        toggleDarkMode()
    }

    const [showBoxPassword, setShowBoxPassword] = useState(false);
    const [showBoxCustom, setShowBoxCustom] = useState(false);
    const [showBoxAddProject, setShowBoxAddProject] = useState(false);
    const [showBoxEditAbout, setShowBoxEditAbout] = useState(false);
    const [showBoxEditHome, setShowBoxEditHome] = useState(false);
    const [passValue, setPassValue] = useState('');
    const [checkPass, setCheckPass] = useState(false);

    const [menuMobile, setMenuMobile] = useState(false)
    const showMenuMobile = () => {
        setMenuMobile(true)
        console.log(menuMobile)
    }

    const handleClose = () => {
        setShowBoxPassword(false)
        setShowBoxCustom(false)
        setShowBoxEditAbout(false)
        setShowBoxAddProject(false)
        setShowBoxEditHome(false)
    }

  
    const passwordlol = passcode

    const springProps = useSpring({
        opacity: showBoxPassword ? 1 : 0,
        transform: showBoxPassword ? 'translateY(0)' : 'translateY(20px)',
    });

    const springCustom = useSpring({
        opacity: showBoxCustom ? 1 : 0,
        transform: showBoxCustom ? 'translateY(0)' : 'translateY(20px)',
    });



    const springCustom1 = useSpring({
        opacity: showBoxAddProject ? 1 : 0,
        transform: showBoxAddProject ? 'translateY(0)' : 'translateY(20px)',
    });

    const springCustom2 = useSpring({
        opacity: showBoxEditAbout ? 1 : 0,
        transform: showBoxEditAbout ? 'translateY(0)' : 'translateY(20px)',
    });

    const springCustom3 = useSpring({
        opacity: showBoxEditHome ? 1 : 0,
        transform: showBoxEditHome ? 'translateY(0)' : 'translateY(20px)',
    });

    const springCustom4 = useSpring({
        opacity: menuMobile ? 1 : 0,
        transform: menuMobile ? 'translateY(0)' : 'translateY(20px)',
    });


    const handleGetText = (value) => {
        setPassValue(value.target.value)
        console.log(value.target.value)
    }

    const enterPass = () => {
        if (passValue === passwordlol) {
            setCheckPass(true)
            setShowBoxPassword(false)
            setShowBoxCustom(true)

        }
        else {
            setCheckPass(false)


        }
    }

    const HideCurrentBox = () => {
        setShowBoxPassword(false)
        setShowBoxCustom(true)
        setShowBoxEditAbout(false)
        setShowBoxAddProject(false)
        setShowBoxEditHome(false)
    }



    const handleShowAddProject = () => {
        setShowBoxPassword(false)
        setShowBoxCustom(false)
        setShowBoxEditAbout(false)
        setShowBoxAddProject(true)
        setShowBoxEditHome(false)
    }

    const handleShowAddAbout = () => {
        setShowBoxPassword(false)
        setShowBoxCustom(false)
        setShowBoxEditAbout(true)
        setShowBoxAddProject(false)
        setShowBoxEditHome(false)
    }

    const handleShowEditHome = () => {
        setShowBoxEditHome(true)
        setShowBoxPassword(false)
        setShowBoxCustom(false)
        setShowBoxEditAbout(false)
        setShowBoxAddProject(false)
    }



    return (
        <div className="main">
            <div className="main-wrap">
                {
                    (showBoxPassword || showBoxCustom || showBoxAddProject || showBoxEditAbout || showBoxEditHome) ? (
                        <div>
                            <div className="box-select-container">

                                {showBoxPassword ? (
                                    <animated.div style={springProps}>
                                        <div className="password-box">
                                            <div className="password-box_wrap-close">
                                                <div className="closebutton">
                                                    <div className="temp-wrap" onClick={handleClose}>
                                                        <Close className="password-box-iconclose"></Close>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="password-box_wrap-input">
                                                <input type="password" onChange={handleGetText} placeholder="**********" />
                                            </div>

                                            <div className="password-box_wrap-button">
                                                <div className="wraptitle-password">
                                                    <h3>YOU NEED A CODE SNIPPET</h3>
                                                    <Block></Block>
                                                </div>
                                                <input className="bnt-enter" onClick={enterPass} type="button" value={'Enter'}></input>
                                            </div>
                                        </div>
                                    </animated.div>
                                ) : (<div></div>)}

                                {showBoxCustom ? (
                                    <animated.div style={springCustom}>

                                        <div className="custom-box">
                                            <div className="close">
                                                <div className="temp-wrap" onClick={handleClose}>
                                                    <Close className="password-box-iconclose"></Close>
                                                </div>
                                            </div>
                                            <span className="wrap-custom-box">
                                                <div className="box-addproject" onClick={handleShowAddProject}>
                                                    <span className="wrap-box-child_custombox">
                                                        <h2>Project</h2>
                                                        <Add size={64}  ></Add>
                                                    </span>
                                                </div>
                                                <div className="box-profile" onClick={handleShowAddAbout}>
                                                    <span className="wrap-box-child_custombox">
                                                        <h2>About</h2>
                                                        <Profile size={64}  ></Profile>
                                                    </span>
                                                </div>
                                                <div className="box-home" onClick={handleShowEditHome}>
                                                    <span className="wrap-box-child_custombox">
                                                        <h2>Home</h2>
                                                        <Shield size={64}  ></Shield>
                                                    </span>
                                                </div>
                                            </span>
                                        </div>
                                    </animated.div>
                                ) : (<div></div>)}


                                {showBoxAddProject ? (
                                    <animated.div style={springCustom1}>
                                        <AddProject onHideBox={HideCurrentBox}></AddProject>
                                    </animated.div>
                                ) : <div></div>}

                                {showBoxEditAbout ? (
                                    <animated.div style={springCustom2}>
                                        <AddAbout onHideBox={HideCurrentBox}></AddAbout>
                                    </animated.div>
                                ) : <div></div>}

                                {showBoxEditHome ? (
                                    <animated.div style={springCustom3}>
                                        <EditHome onHideBox={HideCurrentBox}></EditHome>
                                    </animated.div>
                                ) : <div></div>}



                            </div>
                            <div className="cover-main">
                            </div>
                        </div>) : (<div> </div>)
                }


                {
                    menuMobile ? (<animated.div className='wrap-option-menu-mobile' style={springCustom4}>
                        <div className="">
                            <div className="mobile-close" onClick={() => setMenuMobile(false)}>
                                <Close size={32}></Close>
                            </div>
                            <div className="wrap-mobili-child">
                                <Link className={darkMode ? "nav-item-dark-lo" : "nav-item"} onClick={() => setMenuMobile(false)} to="/">Home</Link>

                                <Link className={darkMode ? "nav-item-dark-lo" : "nav-item"} onClick={() => setMenuMobile(false)} to="/work">Work</Link>

                                <Link className={darkMode ? "nav-item-dark-lo" : "nav-item"} onClick={() => setMenuMobile(false)} to="/about">About</Link>

                                <Link className={darkMode ? "nav-item-dark-lo" : "nav-item"} onClick={() => setMenuMobile(false)} to="/memory">Memory</Link>

                                <div className="wrap-option-custom">
                                    <div className={darkMode ? 'nav-social-dark' : 'nav-social'}>
                                        <Link className="link-socical" to="/" onClick={turnOnDarkMode}>
                                            {darkMode ? <SunFill className="icon-sun" size={64}></SunFill> : <Moonicon className="icon-moon" size={64}></Moonicon>}

                                        </Link>
                                    </div>

                                    <div className={darkMode ? 'nav-social-dark' : 'nav-social'}>
                                        <Link className="link-socical" to="https://www.facebook.com/tran.duythanh.54">
                                            <Fbicon className="icon-fb" size={64}></Fbicon>
                                        </Link>
                                    </div>

                                    <div className={darkMode ? 'nav-social-dark' : 'nav-social'}>
                                        <Link className="link-socical" to="https://www.instagram.com/trduyth4nh/">
                                            <Instaricon className="icon-fb" size={64}></Instaricon>
                                        </Link>
                                    </div>

                                    <div className={darkMode ? 'nav-social-dark' : 'nav-social'}>
                                        <Link className="link-socical" to="https://www.linkedin.com/in/tranduy-thanh-70311a234/">
                                            <Linkedicon className="icon-fb" size={64}></Linkedicon>
                                        </Link>
                                    </div>

                                    <div className={darkMode ? 'nav-social-dark' : 'nav-social'}>
                                        <Link className="link-socical" to="https://github.com/trduyTh4nh">
                                            <Githubicon className="icon-fb" size={64}></Githubicon>
                                        </Link>
                                    </div>

                                    <div className={darkMode ? 'nav-social-dark' : 'nav-social'}>
                                        <Link className="link-socical" to="" onClick={() => { setShowBoxPassword(true) }}>
                                            <Barbox className="icon-fb" size={64}></Barbox>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </animated.div>) : (<></>)
                }

                <div className="wrap-nav">
                    <div className={darkMode ? "wrap-option-menu-dark" : "wrap-option-menu"} onClick={showMenuMobile}>
                        <div className="wrap-iconmenu-option" >
                            <MenuLine size={30}></MenuLine>
                        </div>
                    </div>





                    <div className="wrap-nav_left">

                        <div className="wrap-nav_left-child">
                            <Link className={darkMode ? "nav-item-dark" : "nav-item"} to="/">Home</Link>

                            <Link className={darkMode ? "nav-item-dark" : "nav-item"} to="/work">Work</Link>

                            <Link className={darkMode ? "nav-item-dark" : "nav-item"} to="/about">About</Link>

                            <Link className={darkMode ? "nav-item-dark" : "nav-item"} to="/memory">Memory</Link>
                        </div>
                    </div>



                    <div className="wrap-nav_right">
                        <div className={darkMode ? 'nav-social-dark' : 'nav-social'}>
                            <Link className="link-socical" to="/" onClick={turnOnDarkMode}>
                                {darkMode ? <SunFill className="icon-sun" size={64}></SunFill> : <Moonicon className="icon-moon" size={64}></Moonicon>}

                            </Link>
                        </div>

                        <div className={darkMode ? 'nav-social-dark' : 'nav-social'}>
                            <Link className="link-socical" to="https://www.facebook.com/tran.duythanh.54">
                                <Fbicon className="icon-fb" size={64}></Fbicon>
                            </Link>
                        </div>

                        <div className={darkMode ? 'nav-social-dark' : 'nav-social'}>
                            <Link className="link-socical" to="https://www.instagram.com/trduyth4nh/">
                                <Instaricon className="icon-fb" size={64}></Instaricon>
                            </Link>
                        </div>

                        <div className={darkMode ? 'nav-social-dark' : 'nav-social'}>
                            <Link className="link-socical" to="https://www.linkedin.com/in/tranduy-th4nh-70311a234/">
                                <Linkedicon className="icon-fb" size={64}></Linkedicon>
                            </Link>
                        </div>

                        <div className={darkMode ? 'nav-social-dark' : 'nav-social'}>
                            <Link className="link-socical" to="https://github.com/trduyTh4nh">
                                <Githubicon className="icon-fb" size={64}></Githubicon>
                            </Link>
                        </div>

                        <div className={darkMode ? 'nav-social-dark' : 'nav-social'}>
                            <Link className="link-socical" to="" onClick={() => { setShowBoxPassword(true) }}>
                                <Barbox className="icon-fb" size={64}></Barbox>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>


            <Outlet />
        </div>
    )
}